export class PrimaryAccountCreationRequestModel {
    ContactId: number;
    ClubId?: number;
    FacilityLocationId: number;
    AccountName: string;
    GenericCode: string;
    GenericAccount: string;
    PaymentProviderToken: string;
    SendEmailConfirmation: boolean;
    FeeProcessType: FeeProcessType;
    ExpiryDate: Date;
}

// please use the one in shared 
export enum FeeProcessType {
    DirectDebit = 1,//BACS
    CreditCard = 2,
    SEPA = 5,
    CPA = 6,
    PNZ = 7
}